import { buildAuthFunctions } from '../helpers.js';

const authFunctions = buildAuthFunctions('contacts');

export default authFunctions;